import { usePathname } from 'expo-router';
import { View } from 'react-native';

import { AlertDialog, Text, createMqStyles } from '@fhs/ui';
import { ActionLink } from 'components/action-button';
import { useCartContext } from 'state/cart';
import { routes } from 'utils/routing';

export default function RateLimitedErrorModal() {
  const mqStyles = useMqStyles();
  const pathname = usePathname();
  const { showRateLimitModal } = useCartContext();

  return (
    <AlertDialog
      visible={(pathname === '/cart' || pathname === '/cart/payment') && showRateLimitModal}
      accessibilityLabel="Looks like something went wrong."
      headingContent="Looks like something went wrong."
      bodyContent={
        <Text>
          Please come back again in <Text weight="bold">5 minutes</Text>.
        </Text>
      }
      onClose={() => {}}
      actions={
        <View style={mqStyles.actionsContainer}>
          <ActionLink
            to={routes.menu}
            fullWidth
            noLogOnLongLoading
            testID="CART_PAGE_RATE_LIMITING_BUTTON"
          >
            Okay
          </ActionLink>
        </View>
      }
    />
  );
}

const useMqStyles = createMqStyles({
  actionsContainer: {
    $base: {
      gap: 10,
    },
    $gteDesktop: {
      flexDirection: 'row-reverse',
      flex: 1,
    },
  },
  cta: {
    $gteDesktop: {
      flex: 1,
    },
  },
});
